export default __webpack_public_path__ + "static/media/popup.2c817ab2.png";